module.exports = __webpack_public_path__ + "img/monthly-calendar.9cf6f6b3.png";